const axios = require('axios');

import {VIGEO_URL as baseUrl } from "src/modules/shared/config/config.service"

const SouscriptionVigeoService = {
    /**
     * Récupère les paramètres de configuration pour la souscription vigeo
     */
    getParameters() {
        const url = baseUrl + '/souscription/parameters'
        return axios.get(url)
    },
    /**
     * Récupère les informations de l'utilisateur
     */
    getUserInformations() {
        const url = baseUrl + '/souscription/user'
        return axios.get(url)
    },
    /**
     * Soumets le formulaire de souscription vigeo
     */
    submitForm(data, params) {
        const url = baseUrl + '/souscription/submit'
        return axios.post(url, data, {params: params})
    }
}

export default SouscriptionVigeoService
